import { validateFile } from '@om/validation';
import { UPLOAD_DOCUMENTS_CONFIG, setSizotsaDocumentValid } from '../../../actions/sizotsaFuneralCover/uploadDocuments';

let prevValidationAction = null;
export const uploadDocumentsValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        error =  validateFile(action.value.fileContaint, {
                  minInputSize: UPLOAD_DOCUMENTS_CONFIG.MIN_INPUT_SIZE,
                  minInputSizeName: UPLOAD_DOCUMENTS_CONFIG.MIN_INPUT_SIZE_NAME,
                  maxInputSize: UPLOAD_DOCUMENTS_CONFIG.MAX_INPUT_SIZE,
                  maxInputSizeName: UPLOAD_DOCUMENTS_CONFIG.MAX_INPUT_SIZE_NAME,
                  validFileTypes: UPLOAD_DOCUMENTS_CONFIG.VALID_UPLOAD_TYPES,
                  required:false
              })
            ;
        if (action.value.inputType) {
            return setSizotsaDocumentValid(error, action.value.inputType);
        } else {
            return null;
        }
    })();
    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
